<template>
  <div class="showCityandRule">
    <div class="showCityandRule-1">
      <p class="th">
        <span>{{rule.tit}}</span>
        <img src="//static.daojia.com/fe/jz/daojiaapp/hongbao/image/guide-title.eb435f99.png" alt="">
        <em @click="hideEvent"></em>
      </p>
      <div id="wrapper" class="wrapper">
       <pre>{{rule.con}}</pre>
        <a href="javascript:;" class="know" @click="hideEvent">我知道了</a>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    rule: Object
  },
  methods: {
    hideEvent() {
      var that = this;
      that.$dispatch('ruleFlagEvent',false);
    }
  }
}
</script>



// WEBPACK FOOTER //
// Rule.vue?50b1b930